import { Box, Flex, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { useAppConfig } from "../../context";

import RightSidebarWidget from "./RightSidebarWidget";

function Layout({ sidebar, navbar, children }) {
  const { storedSidebarState, sidebarState } = useAppConfig();

  const sidebarW = useBreakpointValue({
    base: "full",
    md: "14",
    lg: storedSidebarState ? "64" : "14",
  });

  const sidebarBorder = useBreakpointValue({
    base: "none",
    md: "thin",
  });

  const contentOpacity = useBreakpointValue({
    base: sidebarState ? 0 : 1,
    lg: 1,
  });

  const contentPointerEvents = useBreakpointValue({
    base: sidebarState ? "none" : "all",
    lg: "all",
  });

  const navbarBg = useColorModeValue("white", "gray.800");

  return (
    <Flex id="layout" direction="column" blockSize="100vh" inlineSize="full" overflow="hidden">
      {navbar && (
        <Box
          flexGrow={0}
          flexShrink={0}
          insetBlockStart={0}
          position="sticky"
          bg={navbarBg}
          zIndex={2}
          // boxShadow="md"
          borderBottom="1px"
          borderColor="gray.300"
          inlineSize="full"
        >
          {navbar}
        </Box>
      )}
      <Flex flexGrow={1} overflow="hidden" blockSize="full">
        {sidebar && (
          <Box
            borderInlineEndWidth={sidebarBorder}
            inlineSize={sidebarW}
            blockSize="full"
            transitionTimingFunction="ease"
            transitionDuration="200ms"
            bg="#1155a5"
          >
            {sidebar}
          </Box>
        )}
        <Box
          id="layoutContainer"
          flex={1}
          blockSize="full"
          overflowY="auto"
          overflowX="hidden"
          opacity={contentOpacity}
          pointerEvents={contentPointerEvents}
          transitionTimingFunction="ease"
          transitionDuration="200ms"
        >
          <Box flexGrow={1} zIndex={1} backgroundColor="layout_background">
            {children}
          </Box>
          <RightSidebarWidget />
        </Box>
      </Flex>
    </Flex>
  );
}

export default Layout;
